import React from 'react';
import LearnHub from '@/components/Learn/LearnHub';
import LearnSurface from '@/components/Learn/LearnSurface';
import MetaHead from '@/components/MetaHead';

export default function LearnPage() {
  return (
    <LearnSurface>
      <MetaHead
        title="Learn how to use AI — Gab AI"
        description="Free, beginner-friendly lessons and short video tutorials. Write better prompts, create images and video, and get real work done with AI."
        canonical="/learn"
      />
      <LearnHub />
    </LearnSurface>
  );
}
